import { default as Icon } from "@folksam/ui/components/icons/IconCheckmark";

import { Box } from "../cores";

const IconCheckmark = () => {
  return (
    <Box
      as="span"
      sx={{
        color: "secondaryScale.8",
        height: "100%",
      }}
    >
      <Icon />
    </Box>
  );
};

export default IconCheckmark;
